export const R = 180;
export const LIGHT_R = 4;
export const CENTER = [200, 250];
export const INNER_R = 27;
const NUM_FAN = 10;
export const FAN_RADIAN = 2 * Math.PI / NUM_FAN;
